import { Component, OnInit, ViewChild,Input,EventEmitter,Output, Inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatHorizontalStepper, MatDialogRef } from '@angular/material';
import { LoggedinService } from '../../../services/login/loggedin.service';
import { BaseService } from '../../../services/base/base.service';
import { VenueService } from '../../../services/venue/venue.service';
import { DeleteVenueService } from '../../../services/venue/delete-venue/delete-venue.service';
import { VenueTypeService } from '../../../services/venue/venue-type/venue-type.service';
import { SessionHelper } from '../../../shared/services/localstorage';
import {MatPaginator, MatTableDataSource} from '@angular/material';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { of } from 'rxjs';
import { tap, map, filter, every, reduce } from 'rxjs/operators';
import { roleID } from '../../../configurations/configuration';
import { noVenueID } from '../../../configurations/configuration';
import { virtualVenue } from '../../../configurations/configuration';

import { ConfirmationDialog } from '../../../shared/confirm-dialog/confirmation-dialog';
import { NotesService } from '../../../services/event/notes/notes.service';


@Component({
  selector: 'app-venue-list',
  templateUrl: './venue-list.component.html',
  styleUrls: ['./venue-list.component.css']
})
export class VenueListComponent implements OnInit {

  filterObj: any = {};
  includedFields: any;
  venueListObj = [];
  venueList: any;
  pageSize: number = 10;
  pageNumber: number = 1;
  totalRecords: number;
  states = [];
  venueTypes = [];
  searchVenueForm: FormGroup;
  role: number;
  roleID = roleID;
  venueID = noVenueID;
  virtualVenue = virtualVenue;
  reSet=false;
  showLoader: boolean = false;
  showLoaderSearch: boolean = false;
  searchMessage = "";
  noRecordsMsg = '';
  userInfo: any;
  @Input() pageSource: string;
  @Input() eventId: string;
  @Input() eid;
  @Output() pickForMeEvent = new EventEmitter<string>();

  @Output() messageEvent = new EventEmitter<string>();
  @Output() getNotesEvent = new EventEmitter<any>();

  constructor(public loggedinService: LoggedinService, public dialog: MatDialog,
    private venueService: VenueService, private fb: FormBuilder,
    private venueTypeService: VenueTypeService, private baseService: BaseService, private deleteVenueService: DeleteVenueService) { }

  ngOnInit() {
    if(SessionHelper.isLoggedIn()) {
      this.loggedinService.changeStatus(true);
    }
    else {
      this.loggedinService.changeStatus(false);
    }
    this.getVenue();
    this.getVenueType();
    this.getAllStates();
    this.searchVenueForm = this.fb.group({
      'venuename': [''],
      'venuetype': [''],
      'city': [''],
      'state': ['']
    });
    this.userInfo = SessionHelper.getSession();
    console.log("userInfo", this.userInfo);
    this.role = this.userInfo.role_id;
  }
  reset(){
    this.reSet=true;
    this.searchVenueForm.reset();
    this.searchVenues();
  }
  getVenue() {
    this.searchMessage = '';
    this.venueService.getAllVenue({}, 1000, 0).subscribe((result: any) => {
      console.log(result);
      if (result.status) {
        this.venueList = result.data;
        this.totalRecords = result.data.length;
        if(this.venueList.length > 0) {
          this.noRecordsMsg = '';
        }
        else {
          this.noRecordsMsg = 'No records found';
        }
        this.venueList.forEach(element => {
          element.isLoader = false;
        });
      }
      else {
        console.log("Error: ", result.message);
      }
    },
      err => {
        console.log("Error: ", err);
      })
  }

  // pickForMeParent() {
  //   this.pickForMeEvent.next('');
  // }

  requestNewVenue() {
    const dialogRef = this.dialog.open(RequestNewVenueComponent, {
      panelClass: 'request-new-venue-modal',
      data: {
        eventId: this.eid,
        userId: this.userInfo.id,
        pickForMeEvent: this.pickForMeEvent
      }
    });
    dialogRef.afterClosed().subscribe(result => { this.getNotesEvent.next(); });
  }

  filterEmptyFields(data: any): any {
    let fields = {};
    Object.keys(data).forEach(key =>  data[key] != '' &&  data[key] != null ? fields[key] = data[key] : key);
  
    return fields;
  }

  getVenueType() {
    this.venueTypeService.getAllVenueType().subscribe((result: any) => {
      console.log(result);
      if(result.status) {
        this.venueTypes = result.data;
      }
    },
    err => {
      
    });
  }

  getAllStates() {
    this.baseService.getAllStates().subscribe((result: any) => {
      console.log(result);
      this.states = result.data;
    },
    err => {
      
    })
  }

  pageChanged(pN: number): void {
    this.pageNumber = pN;
  }

  public searchVenues() {
    this.noRecordsMsg = "";
    if(this.reSet==true){
      this.includedFields={}
    }else{
      this.includedFields = this.filterEmptyFields(this.searchVenueForm.value);
    }
    this.reSet=false;
    console.log(this.includedFields);
    if(Object.keys(this.includedFields).length > 0) {
      this.showLoaderSearch = true;
    }
    console.log(this.includedFields);
    this.venueService.getAllVenue(this.includedFields, 1000, 0).subscribe((result:any) => {
      console.log("Venue Search Data", result);
      if(result.status) {
        this.showLoaderSearch = false;
        this.venueList= [];
        this.venueList = result.data;
        this.pageSize = 10;
        this.pageNumber = 1;
        this.totalRecords = result.data.length;

        if(this.venueList.length <= 0) {
          this.searchMessage = "Note: If no Venue matches your search criteria, please retry your search with different attributes or Add New Venue by clicking on the button provided above.";
        }
        else if(this.venueList && this.venueList.length === 1 && this.venueList[0].id === virtualVenue.virtualVenueID) {
          this.searchMessage = "Note: If no Venue matches your search criteria, please retry your search with different attributes or Add New Venue by clicking on the button provided above.";
        }
        else if(this.venueList.length > 0) {
          this.searchMessage = '';
        }
      }
    },
    err => {
      this.showLoaderSearch = false;      
    });
  }

  selectVenue(venueObj){
    console.log(venueObj);
    this.messageEvent.emit(venueObj);
    window.scrollTo(0, 350);
  }

  deleteRecord(id) {

    const dialogRef = this.dialog.open(ConfirmationDialog,{ disableClose: true });
    dialogRef.componentInstance.confirmMessage = "Are you sure you want to delete the Venue?";


    dialogRef.afterClosed().subscribe(result => {
      if(result) {
        let obj = {
          id: id,
          is_active: 0
        }
        this.venueList.forEach(element => {
          if(element.id === id) {            
            element.isLoader = true;
          }
        });
        this.deleteVenueService.deleteVenue(obj).subscribe((result: any) => {
          console.log(result)
          if(result.status) {
            this.venueList.forEach((element, index) => {
              if ( element.id === id) {
                this.showLoader = false;
                this.venueList.splice(index, 1); 
              }
            });
          }
        });

      }
    });

  
  }
}

@Component({
  selector: 'app-dialog-data-example-dialog',
  templateUrl: './request-new-venue.html',
  styleUrls: ['./venue-list.component.css']
})
export class RequestNewVenueComponent implements OnInit {
    
  remainingWordCount: number = 1000;
  notesData: any;
  submitted = false;
  showLoader = false;
  enteredNotes: string;
  constructor(public dialog: MatDialog, 
    public dialogRef: MatDialogRef<RequestNewVenueComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private notesservice: NotesService) {}

  ngOnInit() {
    // this.getNotes();
  }

  // getNotes() {
  //   const filterObj = {
  //     eventId: this.data.eventId,
  //   };
  //   this.notesservice.getNotes(filterObj).subscribe((result: any) => {
  //       this.notesData = result.data;
  //   });
  // }
  addNotes(form) {
    if (form.invalid) {
      return;
    }
    this.submitted = true;
    this.showLoader = true;
    const postBody = {
      eventId: this.data.eventId,
      note: this.enteredNotes,
      userId: this.data.userId
    };
    this.notesservice.addNotesInfo(postBody).subscribe((result) => {
      if (result) {
        this.submitted = false;
        this.showLoader = false;
        this.remainingWordCount = 1000;
        // this.getNotes();
        form.reset();
        this.dialogRef.close();
        this.data.pickForMeEvent.next('');
     }
    }, error => {
       console.log(error);
    });
  }

  countTextChar(){
    this.remainingWordCount = 1000
    if(this.enteredNotes){
    console.log(this.enteredNotes.length);
    this.remainingWordCount = this.remainingWordCount - this.enteredNotes.length
    if(this.enteredNotes.length==1)
    this.remainingWordCount = 1000
    }
  }
}